import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ValidationError, validate } from 'class-validator';

import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { CoreService } from '../services/core.service';

import { Domiciliacion } from '../entities/domiciliacion.entity';
import { Contrato } from '../entities/contrato.entity';
import { SolicitudCorrespValidate } from '../entities/SolicitudCorrespValidate.entity.';

@Component({
  selector: 'app-datoscorrespondencia',
  templateUrl: './datoscorrespondencia.component.html'
})
export class DatosCorrespondenciaComponent implements OnInit {

  // Variables de la ventana
  public nombre: string;
  public dni: string;
  public email: string;
  public telefono: string;
  public nombreCorrespondencia: string;
  public direccionCorrespondencia: string;
  public paisCorrespondencia: string;
  public provinciaCorrespondencia: string;
  public poblacionCorrespondencia: string;
  public codigoPostalCorrespondencia: string;
  public datosCorrespondencia: Domiciliacion;
  public direccionSuministro: string;
  public contratoSelected: Contrato;

  // Variables para controlar los errores en los datos modificables de la ventana
  public nombreCorrespondenciaInputError: boolean;
  public direccionCorrespondenciaInputError: boolean;
  public paisCorrespondenciaInputError: boolean;
  public provinciaCorrespondenciaInputError: boolean;
  public poblacionCorrespondenciaInputError: boolean;
  public codigoPostalCorrespondenciaInputError: boolean;


  // Lista países combobox
  public paises : any[] = [];

  // Variables para mostrar avisos
  public messageCabecera: string;
  public typeException: number;
  public messageComplet: string;


  constructor(
    private userService: UserService,
    private sessionService: SessionService,
    private coreService: CoreService,
    private router: Router
  ) { }

  ngOnInit() {
    this.paises = this.getCountries();
    if (this.sessionService.isAuthenicated === true) {      
      this.nombre = this.sessionService.nombre;
      this.dni = this.sessionService.login;
      this.email = this.sessionService.email;
      this.telefono = this.sessionService.telefono;
      this.contratoSelected = this.sessionService.contratoSelected;
      this.CargarDatosContrato(this.sessionService.contratoSelected);

      this.clearInputErrors();
    } else {
      this.router.navigate(['/']);
    }
  }

  public CargarDatosContrato(contrato: Contrato) {
    this.nombreCorrespondencia = contrato.CorrespondenciaNombre;
    this.direccionCorrespondencia = contrato.CorrespondenciaDireccion;
    this.paisCorrespondencia = contrato.CorrespondenciaNacion;
    this.provinciaCorrespondencia = contrato.CorrespondenciaProvincia;
    this.poblacionCorrespondencia = contrato.CorrespondenciaPoblacion;
    this.codigoPostalCorrespondencia = contrato.CorrespondenciaCPostal;
    this.direccionSuministro = contrato.InmuebleBO.Direccion;
  }

  public actualizarDatosCorrespondencia() {
    this.clearInputErrors();

    this.datosCorrespondencia = new Domiciliacion();
    this.datosCorrespondencia.Contrato = this.sessionService.contratoSelected;

    this.datosCorrespondencia.Contrato.EnvioDireccion = this.direccionCorrespondencia;
    this.datosCorrespondencia.Contrato.EnvioNombre = this.nombreCorrespondencia;
    this.datosCorrespondencia.Contrato.EnvioNacion = this.paisCorrespondencia;
    this.datosCorrespondencia.Contrato.EnvioProvincia = this.provinciaCorrespondencia;
    this.datosCorrespondencia.Contrato.EnvioPoblacion = this.poblacionCorrespondencia;
    this.datosCorrespondencia.Contrato.EnvioCpostal = this.codigoPostalCorrespondencia;

    this.datosCorrespondencia.Poblacion = this.sessionService.explotacion;
    this.datosCorrespondencia.UsuarioOnline = this.sessionService.usuario;
    this.datosCorrespondencia.TipoSolicitud = 'corresp';

    validate(this.cargarDatosValidar(this.datosCorrespondencia.Contrato)).then(resultado => {
      if (resultado.length > 0) {
        this.showErrors(resultado);
      } else {
        if (document.getElementById('top') !== null)
          document.getElementById('top').scrollIntoView();
        this.userService.correspondenciaFactura(this.sessionService.explotacion, this.datosCorrespondencia)
          .then(
            response => this.actualizarDatosCorrespondenciaOnSuccess(response),
            response => this.actualizarDatosCorrespondenciaOnError(response)
          );
      }
    });
  }

  public actualizarDatosCorrespondenciaOnSuccess(response) {
    this.messageCabecera = 'Su solicitud ha sido realizada';
    this.typeException = 2;
    this.messageComplet = 'Los datos de correspondencia se han actualizado correctamente.';
  }

  public actualizarDatosCorrespondenciaOnError(response) {
    this.typeException = 1;
    this.messageComplet = 'No se ha podido realizar la solicitud.';
    this.messageCabecera = 'Su solicitud no ha podido ser realizada';
  }

  public recibirContrato(event): void {
    const contratoSelect: Contrato = event.contratoSeleccionado;
    this.CargarDatosContrato(contratoSelect);
    this.clearInputErrors();
  }

  public showErrors(resultado: ValidationError[]) {
    for (let item of resultado) {
      switch (item.property) {
        case 'Nombre':
          this.nombreCorrespondenciaInputError = true;
          break;
        case 'Nacion':
          this.paisCorrespondenciaInputError = true;
          break;
        case 'Provincia':
          this.provinciaCorrespondenciaInputError = true;
          break;
        case 'Poblacion':
          this.poblacionCorrespondenciaInputError = true;
          break;
        case 'Cpostal':
          this.codigoPostalCorrespondenciaInputError = true;
          break;
        case 'Direccion':
          this.direccionCorrespondenciaInputError = true;
          break;
      }
    }
  }

  private clearInputErrors() {
    this.nombreCorrespondenciaInputError = false;
    this.direccionCorrespondenciaInputError = false;
    this.paisCorrespondenciaInputError = false;
    this.provinciaCorrespondenciaInputError = false;
    this.poblacionCorrespondenciaInputError = false;
    this.codigoPostalCorrespondenciaInputError = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
  }

  public cargarDatosValidar(contrato: Contrato): SolicitudCorrespValidate {
    let datosValidar = new SolicitudCorrespValidate();

    datosValidar.Nombre = contrato.EnvioNombre;
    datosValidar.Nacion = contrato.EnvioNacion;
    datosValidar.Provincia = contrato.EnvioProvincia;
    datosValidar.Poblacion = contrato.EnvioPoblacion;
    datosValidar.Direccion = contrato.EnvioDireccion;
    datosValidar.Cpostal = contrato.EnvioCpostal;
    return datosValidar;
  }

  public getCountries() {
    return this.coreService.getCountries();
  }
}
